import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_SalesReturnForm = _resolveComponent("SalesReturnForm")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "edit_sales_return",
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["items"]),
      _createVNode(_component_SalesReturnForm, {
        form: _ctx.form,
        "sale-search": _ctx.saleSearch,
        "sale-search-results": _ctx.saleSearchResults,
        "show-sale-results": _ctx.showSaleResults,
        items: _ctx.items,
        "total-items": _ctx.totalItems,
        "sub-total": _ctx.subTotal,
        "grand-total": _ctx.grandTotal,
        "is-submitting": _ctx.isSubmitting,
        "submit-label": "sales_return_page.update_sales_return",
        "onUpdate:saleSearch": _ctx.handleSaleSearch,
        onFocusSaleSearch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchSales(''))),
        onSelectSale: _ctx.selectSale,
        "onUpdate:status": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.status = $event)),
        "onUpdate:discount": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.discount = $event)),
        "onUpdate:tax": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.tax = $event)),
        "onUpdate:shipping": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.shipping = $event)),
        "onUpdate:note": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.note = $event)),
        onUpdateQty: _ctx.updateItemQuantity,
        onRemoveItem: _ctx.removeItem,
        onSubmit: _ctx.submitSalesReturn
      }, null, 8, ["form", "sale-search", "sale-search-results", "show-sale-results", "items", "total-items", "sub-total", "grand-total", "is-submitting", "onUpdate:saleSearch", "onSelectSale", "onUpdateQty", "onRemoveItem", "onSubmit"]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}